import { combineReducers } from "redux";
import User from "./UserReducer";

// core reducers
import TranslationReducer from "./TranslationReducer";
import admin from "./Admin";

// core actions
import { USER_SIGNED_OUT } from "../actions/UserActions";

import _ from "../constants/Translations";

const allReducers = (state, action, extraReducers = {}) => {
  return combineReducers({
    User,
    admin,
    _: TranslationReducer,
    ...extraReducers,
  })(state, action);
};

const defaultState = { _: _("en") };

export const rootReducer = (appReducers = {}) => {
  return (state = defaultState, action) => {
    if (action.type === USER_SIGNED_OUT) {
      state = defaultState;
    }

    return allReducers(state, action, { ...appReducers });
  };
};
